document.addEventListener("DOMContentLoaded", function(e) {
    // https://trello.com/c/lKcdjxnk/
    io.sub("/ionav/initComplete/", function(e){
        var activemenu = document.querySelector("#ionav-menu-main .activemenu");
        var mainmenuli = document.querySelectorAll("#ionav-menu-main > ul > li");
        for (var i = 0; i < mainmenuli.length; i++) {
            (function(index) { // scope variable instead of "let" for usage with IE
                var ele = mainmenuli[index];
                ele.addEventListener("click", function(event) {
                    event.stopPropagation();
                    var childrenUl = ele.querySelector("ul").cloneNode(true);
                    activemenu.innerHTML = '';
                    activemenu.appendChild(childrenUl);
                }, false);
            })(i);
        }
    });

    // Usage of the IoNav
    let ionav = new IoNav({
        elements: "#menu-main",
        elementsNav: ".ionav-canvas #ionav-menu-main",
        linkSubmenuClickable: false,
        buttonElement: document.querySelector(".custom-ionav-btn"),
        mqlQuery: {
            minWidth: "0px",
            maxWidth: typeof mediaBreakpoint != "undefined" && mediaBreakpoint >= 8000 ? mediaBreakpoint + "px" : "8000px"
        },
        debug: false
    });
});
